<template>
    <b-modal :ref="reference" :id="reference" :title="title" :size="size" no-close-on-backdrop>
        <div class="d-block text-center">
            <div>
                <slot name="body">
                    Sin datos
                </slot>
            </div>
            
            
        </div>
        <template v-slot:modal-footer>
            <div>
                <slot name="cancel-action">
                    <b-button variant="secondary" class="text-white mr-3" @click="hide">
                        <i class="fa fa-times-circle mr-2" aria-hidden="true"></i>
                        <span>{{cancelActionText}}</span>
                    </b-button>
                </slot>
                <slot name="accept-action" >
                    <b-button @click="acceptAction" class="text-white" variant="primary">
                        <i class="fa fa-check-circle mr-2" aria-hidden="true"></i>
                        <span>{{acceptActionText}}</span>
                    </b-button>
                </slot>
            </div>
        </template>
    </b-modal>
</template>

<script>
/* eslint-disable */

export default {
    props: {
        reference: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            required: false,
            default: '',
        },
        cancelActionText: {
            type: String,
            required: false,
            default: 'Cancelar'
        },
        acceptActionText: {
            type: String,
            required: false,
            default: 'Aceptar'
        },
        acceptAction: {
            type: Function,
            required: true
        },
    },
    methods: {
        hide() {
            this.$refs[this.reference].hide();
        }
    }
}
</script>